// Per-route SEO config. Keys are exact pathnames; the `matcher` field can
// be used for dynamic routes (product categories, design details). All
// copy here is written in EUROSTEEL's editorial voice — no keyword lists
// in prose, one primary keyword woven in naturally per meta description.

import { OG_IMAGE_DEFAULT } from "./site";

export const PAGE_META = {
  "/": {
    title:
      "EUROSTEEL — Steel Windows & Doors, New Zealand",
    description:
      "Slim-profile steel windows and doors for New Zealand architecture. Thermally-broken systems, FerroFinestra sight-lines, Auckland showroom by appointment.",
    keywords: [
      "steel windows NZ",
      "steel doors NZ",
      "architectural steel NZ",
      "EUROSTEEL New Zealand",
    ],
    ogType: "website",
    ogImage: OG_IMAGE_DEFAULT,
  },
  "/products": {
    title: "Products — Steel Windows, Doors & Hardware | EUROSTEEL NZ",
    description:
      "Explore the EUROSTEEL range: steel windows, steel doors, luxury entrances and Iver hardware — every profile custom-engineered for New Zealand builds.",
    keywords: [
      "steel windows and doors NZ",
      "custom steel joinery NZ",
      "architectural steel products",
    ],
  },
  "/products/designs": {
    title: "Design Renders — Bespoke Steel Doors & Screens | EUROSTEEL",
    description:
      "A curated gallery of bespoke steel door and screen renders. Every profile, glazing, handle and finish shown here can be tailored to your architectural drawings.",
    keywords: [
      "bespoke steel doors NZ",
      "custom steel screens NZ",
      "steel door designs",
    ],
  },
  "/projects": {
    title: "Projects — Installed Steel Windows & Doors NZ | EUROSTEEL",
    description:
      "Selected projects across New Zealand: heritage villa restorations, pavilion residences and steel-framed interiors detailed in slim-profile FerroFinestra steel.",
    keywords: [
      "steel window projects NZ",
      "architectural steel projects",
      "steel door installations NZ",
    ],
  },
  "/technical": {
    title:
      "Technical — Thermally-Broken, H1-Compliant Steel Systems | EUROSTEEL",
    description:
      "Technical detail for New Zealand specification: thermally-broken steel profiles, double-glazing, H1-compliant sight-lines, hardware options and mounting types.",
    keywords: [
      "thermally broken steel windows NZ",
      "double glazed steel windows NZ",
      "H1 compliant steel windows NZ",
      "steel window specifications NZ",
    ],
  },
  "/finishes": {
    title: "Finishes — Powdercoat & Bronze Options | EUROSTEEL NZ",
    description:
      "Dulux powdercoat and bronze finishes for slim-profile steel windows and doors — matte black, warm bronze and colour-matched paint systems for NZ architecture.",
    keywords: [
      "powdercoat steel windows NZ",
      "steel window finishes NZ",
      "bronze steel doors",
    ],
  },
  "/about": {
    title: "About EUROSTEEL — Architectural Steel Workshop, Auckland",
    description:
      "EUROSTEEL is a New Zealand architectural steel workshop specialising in slim FerroFinestra windows and doors for boutique residential and commercial builds.",
    keywords: ["EUROSTEEL about", "architectural steel workshop NZ"],
  },
  "/contact": {
    title: "Contact — Quotes, Drawings & Showroom | EUROSTEEL NZ",
    description:
      "Send drawings and briefs for quotation. EUROSTEEL project team responds within one business day. Auckland showroom viewings by appointment.",
    keywords: [
      "EUROSTEEL contact",
      "steel joinery quote NZ",
      "Auckland steel window showroom",
    ],
  },
  "/faq": {
    title: "FAQ — Steel Windows & Doors, Lead Times & Care | EUROSTEEL",
    description:
      "Common questions about specifying steel windows and doors in New Zealand — lead times, glazing, hardware, care, warranty and site measurement.",
    keywords: ["steel windows FAQ NZ", "steel doors lead time NZ"],
  },
  "/terms": {
    title: "Terms & Warranty | EUROSTEEL",
    description:
      "EUROSTEEL terms of trade, warranty scope and care instructions for steel windows, doors and hardware supplied in New Zealand.",
    keywords: ["EUROSTEEL warranty", "steel window warranty NZ"],
    noindex: false,
  },
  "/order-status": {
    title: "Track Your Order | EUROSTEEL",
    description:
      "Track a EUROSTEEL order by email — from drawings through fabrication to install.",
    noindex: true,
  },
  "/showroom": {
    title: "Auckland Showroom — By Appointment | EUROSTEEL",
    description:
      "Visit the EUROSTEEL Auckland showroom at 3 Byron Avenue, Takapuna — full-scale steel window and door samples, glazing, hardware. By appointment.",
    keywords: [
      "steel window showroom Auckland",
      "steel door showroom NZ",
      "EUROSTEEL Auckland",
    ],
  },
  "/door-configurator": {
    title: "3D Door Configurator — Design Your Steel Door | EUROSTEEL",
    description:
      "Configure a steel entrance door in 3D — panel style, glazing, handle and finish — then send the spec to the EUROSTEEL workshop for quotation.",
    keywords: [
      "steel door configurator NZ",
      "custom steel door design",
    ],
  },
  "/admin/login": { title: "Admin | EUROSTEEL", noindex: true },
  "/admin/orders": { title: "Admin Orders | EUROSTEEL", noindex: true },
};

// Category-page meta — merged with per-category `seo` data from productCategories.js
export const DEFAULT_CATEGORY_META = {
  ogType: "product",
};
